module.exports = __webpack_public_path__ + "static/img/productPartner_5_1.980fe3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/productPartner/productPartner_5_1.png
// module id = GppJ
// module chunks = 34